import React from "react";
import PropTypes from "prop-types";
import { DropdownSelect } from "../index";

// when we change react version, we'll remove defaultProps
const ClassificationPill = ({
  name = "",
  options,
  extraStyles = {},
  onChange,
  value,
  size = "68px",
}) => (
  <div style={{ ...extraStyles }} className="tw-flex tw-items-center">
    {name}
    <DropdownSelect
      fontSize="1.0rem"
      className="tw-pl-1"
      options={options}
      onSelectChange={onChange}
      value={value}
      selectColor="transparent"
      size={size}
      height="21px"
    />
  </div>
);

ClassificationPill.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({}).isRequired,
  extraStyles: PropTypes.shape({}),
  size: PropTypes.string,
};

ClassificationPill.defaultProps = {
  name: "",
  extraStyles: {},
  size: "68px",
};

export default ClassificationPill;
